import React, { Component } from 'react'
import PropTypes from 'prop-types'

class RiderSharingModal extends Component {
  constructor(props) {
    super(props)

    this.state = {
      roles: null,
      email: null
    }
  }

  render() {
    const { sharedWithMember } = this.props

    const sharedMessage = sharedWithMember ? sharedWithMember.message : null

    return (
      <div className="modal modal-sidebar">
        <ul className="group" data-error-msg={sharedMessage}>
          <label>Share with team member</label>

          <li>
            <span className="unit" data-title="User's email">
              <input
                type="text"
                value={this.state.email || ''}
                onChange={(e) => this.setState({email: e.target.value})} />
            </span>
          </li>

          {/*<li>
            <ul className="collection block">
              <label>Who are you sharing with:</label>

              <li>
                <input
                  id="sharingPermissions-1"
                  type="radio"
                  name="sharingPermissions"
                  onChange={() => this.setState({roles: ['band_member']})} />

                <label htmlFor="sharingPermissions-1">
                  <span></span>
                  <span className="input-label">Band member</span>
                </label>
              </li>

              <li>
                <input
                  id="sharingPermissions-2"
                  type="radio"
                  name="sharingPermissions"
                  onChange={() => this.setState({roles: ['sound_engineer']})} />

                <label htmlFor="sharingPermissions-2">
                  <span></span>
                  <span className="input-label">Sound engineer</span>
                </label>
              </li>

              <li>
                <input
                  id="sharingPermissions-3"
                  type="radio"
                  name="sharingPermissions"
                  onChange={() => this.setState({roles: ['band_member', 'sound_engineer']})} />

                <label htmlFor="sharingPermissions-3">
                  <span></span>
                  <span className="input-label">Sound engineer with band privileges</span>
                </label>
              </li>
            </ul>
          </li>*/}
        </ul>

        <button onClick={() => {
          this.props.shareRider(this.state.roles, this.state.email)
          // this.props.setModal(false)
        }}>Share</button>

        <button className="btn-back" onClick={() => this.props.setModal(false)}>Go back</button>
      </div>
    )
  }
}

RiderSharingModal.propTypes = {
  sharedWithMember: PropTypes.object,
  shareRider: PropTypes.func,
  setModal: PropTypes.func
}

RiderSharingModal.defaultProps = {
  sharedWithMember: {},
  shareRider: function() {},
  setModal: function() {}
}

export default RiderSharingModal



// WEBPACK FOOTER //
// ./src/components/modals/rider-sharing-modal.js